// extracted by mini-css-extract-plugin
var _1 = "x1eqaopb1bXpQMNr4CRB";
var _2 = "Qjix2wM4kIMAYpLB72w5";
var _3 = "lsEYcoYqvH0wjcGGEN0o";
var _4 = "pCq8Dtxr_xUj3R_hIFYz";
var _5 = "NEGyXm4AqdO_WMcvHUak";
var _6 = "ArTSCtivk6NhVII2CAQC";
var _7 = "ddkwSO513RA9TmREcHOQ";
var _8 = "Nf9KnK9xpS7FRcKhfQLo";
var _9 = "EvAVAsGXUpqazB7OmAq1";
var _a = "ak_ez69OZKGeBXCGtnKg";
var _b = "IlZu48R3WUa9ztZePAgO";
var _c = "PqnjD0_qMCBzTafM2AUQ";
export { _1 as "button", _2 as "buttonType-default", _3 as "buttonType-tight", _4 as "buttonType-wide", _5 as "color-gray", _6 as "color-primary", _7 as "color-red", _8 as "fontSize-middle", _9 as "fontSize-small", _a as "fontWeight-bold", _b as "invisible", _c as "loaderWrapper" }
